import { CoreIcon } from '../core-icon';
import pointCircleSVG from '../../assets/icons/point-circle.svg';
import type { IconProps } from '../core-icon';

export const PointCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={pointCircleSVG} {...props} />;
};
